<template>
  <div class="slideBox sessions-app" :class="this.$route.query.source">

    <div class="slideHeader">
      <h1>
        <span class="source">{{ this.$route.query.sourceTitle }}</span>
        Sitzungen
      </h1>
    </div>

    <div class="layoutWrapper">
      <div class="layoutBox box1">
        <h2>Letzte 7 Tage</h2>
        <line-chart class="lineChart" v-if="chartdata" :data="chartdata" :height="100"></line-chart>

        <div class="total-value sessions-app-total">
          <div class="big value">
            <i-count-up
              :start="0"
              :end="sessionWebTotalValue"
              :duration="countDuration"
              :options="options"
            ></i-count-up>
          </div>
          <div class="day">Gestern</div>
        </div>
      </div>

      <div class="layoutBox box2">
        <div class="circles">

          <transition name="swap-in" appear>
            <div class="circle sessions-app-7days" :class="[days7Value < 0 ? 'down' : 'up']">
              <div class="big value">{{ days7Value.toString().replace('.', ',') }}%</div>
              <div class="day">
                <span class="day-range-firstValue">Gestern</span>
                <span class="day-range-divider"></span>
                <span class="day-range-secondValue">7 Tage zuvor</span>
              </div>
            </div>
          </transition>

          <transition name="swap-in" appear>
            <div class="circle sessions-app-14days" :class="[days14Value < 0 ? 'down' : 'up']">
              <div class="big value">{{ days14Value.toString().replace('.', ',') }}%</div>
              <div class="day">
                <span class="day-range-firstValue">Gestern</span>
                <span class="day-range-divider"></span>
                <span class="day-range-secondValue">14 Tage zuvor</span>
              </div>
            </div>
          </transition>

          <transition name="swap-in" appear>
            <div class="circle sessions-app-21days" :class="[days21Value < 0 ? 'down' : 'up']">
              <div class="big value">{{ days21Value.toString().replace('.', ',') }}%</div>
              <div class="day">
                <span class="day-range-firstValue">Gestern</span>
                <span class="day-range-divider"></span>
                <span class="day-range-secondValue">21 Tage zuvor</span>
              </div>
            </div>
          </transition>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ICountUp from 'vue-countup-v2'
import LineChart from '@/components/charts/line-chart'
import _ from 'lodash'
import moment from 'moment'

export default {
  name: 'sessions-app',
  components: {
    ICountUp,
    LineChart
  },
  data () {
    return {
      countDuration: this.$store.state.countDuration,
      sessionWebTotalValue: 0,
      days7Value: 0,
      days14Value: 0,
      days21Value: 0,
      chartdata: null,
      chartColor: '#2d76bf',
      options: {
        useEasing: true,
        useGrouping: true,
        separator: '.'
      }
    }
  },
  mounted () {
    const self = this
    const theme = this.$route.query.theme
    const source = this.$route.query.source
    const urlPart = theme + '-' + source + '_sessions_app'
    const currentSlide = this.$store.state.allSlides[this.$route.query.id]

    /* get chart color */
    if (currentSlide.chartColor) {
      this.chartColor = currentSlide.chartColor
    }

    /* total value */
    const totalValueURL = urlPart + '-yesterday'
    self.axios.get(totalValueURL).then((response) => {
      self.sessionWebTotalValue = parseInt(_.head(response.data.results)['App Sitzungen'])
    })

    /* chart data */
    const chartDataURL = urlPart + '-last_7_days'
    self.axios.get(chartDataURL).then((response) => {
      self.fillData(response.data.results)
    })

    /* 7 days */
    const days7ValueURL = urlPart + '-yesterday_vs_7_days_ago'
    this.axios.get(days7ValueURL).then((response) => {
      this.days7Value = _.head(response.data.results).perc
    })

    /* 14 days */
    const days14ValueURL = urlPart + '-yesterday_vs_14_days_ago'
    this.axios.get(days14ValueURL).then((response) => {
      this.days14Value = _.head(response.data.results).perc
    })

    /* 21 days */
    const days21ValueURL = urlPart + '-yesterday_vs_21_days_ago'
    this.axios.get(days21ValueURL).then((response) => {
      this.days21Value = _.head(response.data.results).perc
    })
  },
  methods: {
    fillData (data) {
      const sessions = []
      const days = []

      /* fill arrays */
      _.each(data, (entry) => {
        sessions.push(parseInt(entry['App Sitzungen']))
        days.push(moment(entry._time).locale('de').format('dd D'))
      })

      this.chartdata = {
        labels: days,
        datasets: [
          {
            pointBackgroundColor: '#fff',
            label: 'Sitzungen',
            backgroundColor: this.chartColor,
            data: sessions
          }
        ]
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/sessions-app.vue